import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getPhaseGoalsForCurrentPhase } from '../../../redux/Game/selectors';
import PhaseGoal from './PhaseGoal';
import Title from '../../baseComponents/Title';
import { SettingsActions } from '../../../redux/Settings';

const Container = styled.div`
  align-content: center;
  justify-content: center;
  margin-bottom: 32px;
`;

const PhaseGoals = () => {
  const dispatch = useDispatch();
  const goals = useSelector((state) => getPhaseGoalsForCurrentPhase(state));
  let phaseGoals = [];
  phaseGoals = goals.map((goal) => {
    return (
      <PhaseGoal
        key={goal.id}
        phaseGoal={goal}
        onChange={() => dispatch(SettingsActions.setPhaseGoalState(goal))}
      />
    );
  });

  return (
    <Container>
      <Title text="Phase Goals" />
      {phaseGoals}
    </Container>
  );
};

export default PhaseGoals;
